import { clsx } from 'clsx';
import type { WidgetArticleDetailHeadProps } from 'components/partials/widget/article-detail/head/head';
import Image from 'components/UI/Image/Image';
import { SponsoredIconFull } from 'components/UI/SponsoredIcon';
import styles from './autonative-article-detail.module.scss';

const AutonativeArticleDetailHead = ({
  context,
  isSponsored,
}: {
  context: WidgetArticleDetailHeadProps;
  isSponsored?: boolean;
}) => {
  const width = 1200;
  return (
    <>
      {isSponsored && <SponsoredIconFull />}
      {context.items?.map((item) => {
        const dateObject = new Date(item.model.lastmodifiedAt);

        return (
          <div key={item.id} className={clsx(styles.articleHead, 'native-article-head')}>
            <h2 className={styles.subtitle}>{item.model.fields.subtitle}</h2>
            <h2 className={styles.title}>{item.model.fields.title}</h2>
            <div>
              <Image image={item.model.image} width={width} alt={item.model.fields.title} />
              <div className={clsx(styles.imageInfo, 'native-article-head__text')}>
                <div className={styles.xsmall}>Image subtext</div>
                <div className={clsx(styles.xsmall, 'article-head__image-copyright')}>© copyRight</div>
              </div>
            </div>
            <time className={styles.time}>
              {dateObject.toLocaleDateString('de-DE', {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
              })}
              &nbsp;um&nbsp;
              {dateObject.toLocaleTimeString('de-DE', {
                hour: '2-digit',
                minute: '2-digit',
              })}
              &nbsp;Uhr
            </time>
          </div>
        );
      })}
    </>
  );
};
export default AutonativeArticleDetailHead;
